import { useEffect } from "react"
import { MOBILE_VIEWPORT_MEDIA } from "@ui/utils/mobileViewport"
import { DS } from "../ds/Kit"

// Visual tokens for the standalone "private" (personal) interface.
// Personal accounts must read differently from the corporate console at a glance:
// a light "private banking" look (cream, graphite, gold) instead of the navy console.
// Kit blocks pick this up through the CSS variables in PRIVATE_SKIN.
export const PRIVATE_SKIN: Record<string, string> = {
	"--ds-accent": "#2B2A28",
	"--ds-accent-soft": "#EEEEEC",
	"--ds-accent-ink": "#1C1B19",
	"--ds-accent-line": "#D9D8D5",
	"--ds-gradient": "linear-gradient(180deg, #3A3835 0%, #232220 100%)",
	"--ds-hero-gradient": "linear-gradient(135deg, #3B3934 0%, #262523 55%, #141413 100%)",
	"--ds-stage-bg": "radial-gradient(90% 120% at 0% 0%, #ECECEA 0%, rgba(236,236,234,0) 60%), radial-gradient(70% 90% at 100% 100%, #F2F2F0 0%, rgba(242,242,240,0) 60%), #FAFAF9",
	"--ds-card-face": "linear-gradient(135deg, #2E2C29 0%, #121211 100%)",
	"--ds-card-glow": "rgba(212, 178, 106, .22)",
	"--ds-card-edge": "rgba(212, 178, 106, .38)",
	"--ds-card-ring": "rgba(212, 178, 106, .5)",
	"--ds-logo-bg": "#2B2A28",
	"--ds-logo-line": "#D4B26A",
	"--v2-accent": "#2B2A28",
}

/** Applies the personal skin to the whole document while a private screen is mounted. */
export const usePrivateSkin = () => {
	useEffect(() => {
		const root = document.documentElement
		Object.entries(PRIVATE_SKIN).forEach(([name, value]) => root.style.setProperty(name, value))
		return () => Object.keys(PRIVATE_SKIN).forEach(name => root.style.removeProperty(name))
	}, [])
}

export const PRIVATE_THEME = {
	appBg: "#F4F4F3",
	surface: DS.surface,
	surfaceSoft: "#F7F7F6",
	sidebarBg: "#FAFAF9",
	sidebarMuted: "#6B6B69",
	accent: DS.accent,
	accentHover: DS.accentInk,
	accentSoft: DS.accentSoft,
	mint: "#B08A3E",
	text: DS.ink,
	muted: DS.muted,
	border: "#E6E6E3",
	success: "#0B9B6B",
	warning: "#B7791F",
	danger: "#D94B64",
	cardShadow: DS.shadow,
	elevatedShadow: "0 12px 28px rgba(43, 42, 40, 0.22)"
}

export const PRIVATE_MOBILE_BREAKPOINT = MOBILE_VIEWPORT_MEDIA
export const PRIVATE_NARROW_BREAKPOINT = "@media (max-width: 480px)"
